module.exports = __webpack_public_path__ + "static/media/neckband-template-small.628a0f50.jpg";